import React, { useState } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';


// ====================
// SELECT INPUT
// ====================

export const SelectButtonItem = React.forwardRef(({ name, className, value, selected, children, onSelect }, ref) => (
  <div 
    className={cx('select-button-item', className, name, { selected })} 
    onClick={() => onSelect(value, name)}>
    { children }
  </div>
))


export const SelectButtons = React.forwardRef(({ className, name, value, children = [], onChange, ...props }, ref) => {
  const [ selectedValue, setSelectedValue ] = useState(0);

  const onSelectItem = (value, name) => {
    onChange?.(value, name);
  }

  return (
  <div
    {...props}
    ref={ref}
    className={cx("select-buttons", 'row', 'center', className)}>
      { children.map((element, idx) => React.cloneElement( 
          element, 
          { ...element.props,
            key: element.props.value,
            onSelect: onSelectItem,
            selected: element.props.value === value },
          element.props.children))}
    </div>)
})
export default SelectButtons;